/**
 * E2 -- a code, key or reference, isolated from the bidi algorithm.
 *
 * The sibling of `<Figure>`, and separate from it on purpose. A figure
 * is a quantity: a count, a ratio, a version. An identifier is a NAME
 * that happens not to be prose -- `marsad-default-unsigned`,
 * `3.1.1-CR7`, `BSVC0001`, a slug, a connector kind. Both need the same
 * isolation and they are read differently, so the surface says which it
 * is rather than the reader inferring it from a monospace font.
 *
 * Why a second component rather than widening Figure: round 7 found the
 * direction work had landed instance by instance, so neighbouring
 * screens disagreed about the same kind of value. One component per
 * kind of value, used everywhere, is the thing that stops that -- and
 * a component named for what it holds is one somebody reaches for
 * correctly without reading its implementation.
 *
 * The isolate itself lives in index.css with the other direction rules,
 * so one place governs how these behave.
 */
export function Identifier({ children }: { children: React.ReactNode }) {
  return <span className="marsad-figure font-mono">{children}</span>;
}
